<template>
  <div>
    <Button
      v-if="!single"
      style="margin-bottom: 10px"
      @click="add"
      type="primary"
      size="small"
      >添加</Button
    >
    <cTable
      :fields="fields"
      :footer="footer"
      :header="header"
      :methods="methods"
      :config="config"
      ref="table"
    >
    </cTable>
  </div>
</template>

<script>
import {
  getFreightRule,
  add,
  getDetails,
  update,
  del,
  getCheckFreigh,
} from "@/api/finance/freightrule";

import cTable from "@/base/common/index";

export default {
  inject: ["$page"],
  components: {
    cTable,
  },
  props: {
    single: {
      type: Boolean,
      default: false,
    },
    rows: {
      type: Object,
    },
  },
  methods: {
    add() {
      let time = Date.now();
      let obj = {
        nas_handle_unit: "KG",
        threshold_values: this.rows.rules[0]["threshold_values"],
        duty_rate: 0,
        insurance_rate: 0,
        paper_fee: 0,
        bayan: 0,
        clearance_fee: 0,
        bank_fee: 0,
        legalization_fee: 0,
        paper_fee_usd: 0,
        global_fee: 0,
        nas_handle_price: 0,
        usd_to_rate: 0,
        vat_rate: 0,
        batch_no: time,
        batch_no_: time,
        use_values_type: 1,
        handling_fee: 0,
        administration_fee: 0,
      };
      this.rows.rules.push(
        Object.assign({ threshold_type: 1 }, obj),
        Object.assign({ threshold_type: 2 }, obj)
      );
    },
  },
  mounted() {
    console.log(this.rows);
    let time = Date.now();
    if (this.rows.rules.length <= 0) {
      let obj = {
        nas_handle_unit: "KG",
        threshold_values: 0,
        duty_rate: 0,
        insurance_rate: 0,
        paper_fee: 0,
        bayan: 0,
        clearance_fee: 0,
        bank_fee: 0,
        legalization_fee: 0,
        paper_fee_usd: 0,
        global_fee: 0,
        nas_handle_price: 0,
        usd_to_rate: 0,
        vat_rate: 0,
        batch_no: time,
        use_values_type: 1,
        handling_fee: 0,
        administration_fee: 0,
      };
      this.rows.rules.push(
        Object.assign({ threshold_type: 1 }, obj),
        Object.assign({ threshold_type: 2 }, obj)
      );
    } else {
    }
    this.rows.rules.forEach((t) => {
      t.batch_no_ = t.batch_no;
    });
    this.$refs["table"].list = this.rows.rules;
  },
  watch: {
    "rows.rules"(newValue, oldValue) {
      if (!newValue.length) {
        let time = Date.now();
        let obj = {
          nas_handle_unit: "KG",
          threshold_values: 0,
          duty_rate: 0,
          insurance_rate: 0,
          paper_fee: 0,
          bayan: 0,
          clearance_fee: 0,
          bank_fee: 0,
          legalization_fee: 0,
          global_fee: 0,
          nas_handle_price: 0,
          paper_fee_usd: 0,
          usd_to_rate: 0,
          vat_rate: 0,
          batch_no: time,
          batch_no_: time,
          use_values_type: 1,
          handling_fee: 0,
          administration_fee: 0,
        };
        this.rows.rules.push(
          Object.assign({ threshold_type: 1 }, obj),
          Object.assign({ threshold_type: 2 }, obj)
        );
      }
    },
  },
  data() {
    return {
      methods: {},
      config: {
        slot: "div",
        height: 300,
        resize: false,
        rows: this.rows,
        mergeRows: [
          "batch_no",
          "threshold_values",
          "use_values_type",
          "start_time",
          "end_time",
          "batch_no_",
        ],
        mergeRow: "batch_no",
      },
      header: {
        config: {
          custom: false,
        },
        searchs: [],
      },
      footer: {
        show: () => false,
      },
      fields: [
        {
          name: () => this.$t("batch_number"),
          key: "batch_no",
          minWidth: 130,
        },
        {
          name: () => this.$t("Threshold Type"),
          key: "threshold_type",
          minWidth: 130,
          methods: {
            render({ value }) {
              return value == 1 ? this.$t("Low") : this.$t("High");
            },
          },
        },
        {
          name: () => this.$t("Declared Currency Type"),
          key: "use_values_type",
          minWidth: 170,
          component: "Select",
          default: 1,
          methods: {
            list({ field }) {
              field.options = [
                { label: this.$t("Fixed USD"), value: 1 },
                { label: this.$t("Destination Currency"), value: 2 },
              ];
            },
          },
        },
        {
          name: () => this.$t("Threshold Values"),
          key: "threshold_values",
          minWidth: 170,
          component: "InputNumber",
          default: 0,
          bind: {
            style: "width:100%",
          },
        },
        {
          name: () => this.$t("USD To Destination Currency Rate"),
          key: "usd_to_rate",
          minWidth: 160,
          component: "InputNumber",
          default: 0,
          bind: {
            style: "width:100%",
            min: 0,
            step: 0.1,
          },
        },
        {
          name: () => this.$t("Duty Rate"),
          key: "duty_rate",
          minWidth: 130,
          component: "InputNumber",
          default: 0,
          bind: {
            style: "width:100%",
            max: 100,
            min: 0,
            step: 0.1,
            formatter: (value) => `${value}%`,
            parser: (value) => value.replace("%", ""),
          },
        },
        {
          name: () => this.$t("VATRate"),
          key: "vat_rate",
          minWidth: 130,
          component: "InputNumber",
          default: 0,
          bind: {
            style: "width:100%",
            max: 100,
            min: 0,
            step: 0.1,
            formatter: (value) => `${value}%`,
            parser: (value) => value.replace("%", ""),
          },
        },
        {
          name: () => this.$t("Paper Fee") + "/USD",
          key: "paper_fee_usd",
          minWidth: 140,
          component: "InputNumber",
          default: 0,
          bind: {
            style: "width:100%",
          },
        },
        {
          name: () => this.$t("Paper Fee") + "/" + this.$t("allow_arrive"),
          key: "paper_fee",
          minWidth: 150,
          component: "InputNumber",
          default: 0,
          bind: {
            style: "width:100%",
          },
          // disabled:true,
        },
        {
          name: () => this.$t("Insurance Rate"),
          key: "insurance_rate",
          minWidth: 130,
          component: "InputNumber",
          default: 0,
          bind: {
            style: "width:100%",
            max: 100,
            min: 0,
            step: 0.1,
            formatter: (value) => `${value}%`,
            parser: (value) => value.replace("%", ""),
          },
        },

        {
          name: () => this.$t("bayan"),
          key: "bayan",
          minWidth: 130,
          component: "InputNumber",
          default: 0,
          bind: {
            style: "width:100%",
          },
        },
        {
          name: () => this.$t("Clearance Fee"),
          key: "clearance_fee",
          minWidth: 130,
          component: "InputNumber",
          default: 0,
          bind: {
            style: "width:100%",
          },
        },
        {
          name: () => this.$t("HandlingFee"),
          key: "handling_fee",
          minWidth: 130,
          component: "InputNumber",
          default: 0,
          bind: {
            style: "width:100%",
          },
        },
        {
          name: () => this.$t("Administration fee"),
          key: "administration_fee",
          minWidth: 130,
          component: "InputNumber",
          default: 0,
          bind: {
            style: "width:100%",
          },
        },
        {
          name: () => this.$t("Bank Fee"),
          key: "bank_fee",
          minWidth: 130,
          component: "InputNumber",
          default: 0,
          bind: {
            style: "width:100%",
          },
        },
        {
          name: () => this.$t("Legalization Fee"),
          key: "legalization_fee",
          minWidth: 130,
          component: "InputNumber",
          default: 0,
          bind: {
            style: "width:100%",
          },
        },
        {
          name: () => this.$t("Global Fee"),
          key: "global_fee",
          minWidth: 130,
          component: "InputNumber",
          default: 0,
          bind: {
            style: "width:100%",
          },
        },
        {
          name: () => this.$t("Nas Handle Price"),
          key: "nas_handle_price",
          minWidth: 140,
          component: "InputNumber",
          default: 0,
          bind: {
            style: "width:100%",
          },
        },
        {
          name: () => this.$t("Nas Handle Unit"),
          key: "nas_handle_unit",
          minWidth: 130,
        },
        {
          key: "start_time",
          name: () => this.$t("start") + this.$t("time"),
          component: "DatePicker",
          minWidth: 200,
          placeholder() {
            return (
              this.$t("select") +
              this.$t("start") +
              this.$t("date") +
              this.$t("time")
            );
          },
          bind: {
            type: "date",
            style: {
              width: "175px",
            },
          },
        },
        {
          key: "end_time",
          name: () => this.$t("end") + this.$t("time"),
          component: "DatePicker",
          minWidth: 200,
          placeholder() {
            return (
              this.$t("select") +
              this.$t("end") +
              this.$t("date") +
              this.$t("time")
            );
          },
          bind: {
            type: "date",
            style: {
              width: "175px",
            },
          },
        },

        {
          name: () => this.$t("Remarks"),
          key: "remarks",
          minWidth: 140,
          component: "Input",
          default: 0,
          bind: {
            style: "width:100%",
          },
        },
        //    {
        //      name: () => this.$t("start") + this.$t("date"),
        //      key: "start_time",
        //      width: 140,
        // component:'DatePicker'
        //    },
        //    {
        //      name: () => this.$t("end") + this.$t("date"),
        //      key: "end_time",
        //      width: 140,
        // component:'DatePicker'
        //    },
        {
          type: "btns",
          key: "batch_no_",
          width: 120,
          name: () => this.$t("operation"),
          fixed: "right",
          show: () => !this.single,
          list: [
            {
              name: () => this.$t("delete"),
              type: "delete",
              fnName: "delete",
              show: () => !this.single,
              bind: {
                type: "error",
              },
            },
          ],

          methods: {
            delete({ row, rowIndex }) {
              this.list.splice(rowIndex, 1);
              this.list.splice(rowIndex, 1);
            },
          },
        },
      ],
    };
  },
};
</script>
